import mutations from './allEesztReports.mutations'
import actions from './allEesztReports.actions'
import getters from './allEesztReports.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
